<script setup lang="ts">
import ArrowRight from "@/js/svg/ArrowRight.vue";
import { BECOME_A_PROVIDER_CARDS } from "./shared";
import BecomeAProviderItem from "./BecomeAProviderItem.vue";

defineProps<{
    providerLink: string;
}>();
</script>

<template>
    <section
        class="bg-misty-pine-0 gap-9 w-full py-12 px-4 md:px-6 flex flex-col items-center lg:px-16 lg:py-12"
    >
        <div class="w-full flex flex-col items-center gap-4">
            <h2
                class="font-bold font-mulish text-28 md:text-32 lg:text-36 leading-10 text-custom-black"
            >
                Become a course provider
            </h2>
            <p
                class="font-normal font-mulish text-16 leading-6 text-sonic-silver"
            >
                Join Vidda Hub’s network of trusted training providers and help
                shape the future of compliance in banking
            </p>
        </div>
        <div class="w-full grid grid-cols-1 lg:grid-cols-3 gap-6">
            <BecomeAProviderItem
                v-for="card in BECOME_A_PROVIDER_CARDS"
                :key="card.id"
                :card="card"
            />
        </div>
        <a :href="providerLink" class="primary-button min-w-[21.25rem]"
            ><span class="font-mulish text-16">Become a provider</span>
            <ArrowRight class="text-20 text-white"
        /></a>
    </section>
</template>
